import React from "react";
import { IconCopy, IconExclamationMark } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { SUPPORT_EMAIL } from "utils";
import useToast from "hooks/useToast";

const OrganisationNoLicense = (props: {
  organisationID?: string;
  containerClassName?: string;
}) => {
  const { t } = useTranslation();
  const toast = useToast();

  const copyOrganisationID = () => {
    if (props.organisationID === undefined) return;
    navigator.clipboard.writeText(props.organisationID);
    toast(t("dashboard.organisationIDCopiedMessage"), "success");
  };

  const copyEmailAddress = () => {
    navigator.clipboard.writeText(SUPPORT_EMAIL);
    toast(t("dashboard.emailCopiedMessage"), "success");
  };

  return (
    <div className={props.containerClassName}>
      <div className="flex items-center p-4 mb-2">
        <IconExclamationMark
          size={16}
          stroke={3}
          className="text-red-500 bg-red-100 rounded-full min-w-[24px] min-h-[24px] p-1 mr-2"
        />
        <div className="text-red-700 text-xs bg-transparent border-none font-medium">
          {t("organisationSettings.organisationNoLicense", {
            org_id: props.organisationID,
          })}
        </div>
      </div>
      <div className="flex flex-col justify-center items-center font-semibold text-indigo-700">
        <div
          className="text-xs mb-2 flex items-center h-6 cursor-pointer"
          onClick={copyOrganisationID}
        >
          <IconCopy stroke={3} className="w-4 h-4 mr-1" size={16} />
          <span>{t("organisationSettings.copyOrganisationID")}</span>
        </div>
        <div
          className="text-xs flex items-center h-6 cursor-pointer"
          onClick={copyEmailAddress}
        >
          <IconCopy stroke={3} className="w-4 h-4 mr-1" size={16} />
          <span>{t("organisationSettings.copyEmailAddress")}</span>
        </div>
      </div>
    </div>
  );
};

export default OrganisationNoLicense;
